// Mirrors backend/app/main.py's _is_age_verified_adult — the same
// fail-closed definition, client-side, used only for UI decisions (which
// gate to show, whether to fetch at all). Never trusted as enforcement —
// the server re-checks on every request regardless of what the client
// believes, since a client-side value can always be spoofed.
export const ADULT_AGE_RANGES = ["18 – 24", "25 – 34", "35 – 44", "45 – 54", "55 – 64", "65 and above"];

export const isAdultAgeRange = (ageRange) => ADULT_AGE_RANGES.includes(ageRange);

export const isAgeVerifiedAdult = (user) => !!user && isAdultAgeRange(user.age_range);
